import { get, writable } from 'svelte/store';
import { conversationId, endCall, inviteCall } from '$lib/websocket-client.js';
import { playRing, stopRing } from '$lib/audio.js';

export const activeCall = writable(null);
export const incomingCall = writable(null);
export const callNotice = writable(null);

let noticeTimer = null;

export function showCallNotice(message, tone = 'info') {
  clearTimeout(noticeTimer);
  callNotice.set({ message, tone });
  noticeTimer = setTimeout(() => callNotice.set(null), 4500);
}

export function startOutgoingCall({
  conversationId: cid,
  callType = 'video',
  title = '',
  iceTransportPolicy = undefined,
  mediaRoute = undefined
}) {
  if (!cid) return false;
  if (get(activeCall) || get(incomingCall)) {
    showCallNotice('Bạn đang có một cuộc gọi khác.', 'warning');
    return false;
  }

  activeCall.set({
    conversationId: cid,
    callType,
    title,
    iceTransportPolicy,
    mediaRoute,
    direction: 'outgoing',
    status: 'ringing',
    startedAt: Date.now()
  });

  if (!inviteCall(cid, callType, { iceTransportPolicy, mediaRoute })) {
    activeCall.set(null);
    showCallNotice('Chưa kết nối được máy chủ cuộc gọi.', 'error');
    return false;
  }

  return true;
}

export function receiveIncomingCall(call) {
  if (!call?.conversationId) return;

  if (get(activeCall) || get(incomingCall)) {
    endCall(call.conversationId, { reason: 'busy' });
    return;
  }

  incomingCall.set(call);
  playRing();
}

export function acceptIncomingCall() {
  const call = get(incomingCall);
  if (!call) return;

  stopRing();
  incomingCall.set(null);
  conversationId.set(call.conversationId);
  activeCall.set({
    ...call,
    direction: 'incoming',
    status: 'connecting',
    startedAt: Date.now()
  });
}

export function rejectIncomingCall(reason = 'declined') {
  const call = get(incomingCall);
  if (!call) return;

  stopRing();
  incomingCall.set(null);
  endCall(call.conversationId, { reason });
}

export function dismissIncomingCall() {
  stopRing();
  incomingCall.set(null);
}

export function updateActiveCall(patch) {
  activeCall.update((call) => (call ? { ...call, ...patch } : call));
}

export function closeActiveCall({ notifyServer = true, reason = 'ended' } = {}) {
  const call = get(activeCall);
  if (!call) return;

  if (notifyServer) endCall(call.conversationId, { reason });
  activeCall.set(null);
}

export function clearAllCalls() {
  stopRing();
  incomingCall.set(null);
  activeCall.set(null);
}
